import '@vfde-brix/interaction-bar/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/notification/dist/styles.css';
import { createInteractionBarComponent } from '@vfde-brix/interaction-bar';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-interaction-bar', createInteractionBarComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);
